<template>
  <div class="step-header" :class="{ 'step-header--strong': strong }">
    <h2 class="step-header__heading" v-html="text"/>
    <small class="step-header__step">Krok {{ step }}/{{ stepCount }}</small>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    step: {
      type: [Number, String],
      default: 1
    },
    stepCount: {
      type: [Number, String],
      default: 3
    },
    strong: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .step-header {
    @include font($akrobat-font, 300);
    text-transform: uppercase;
    letter-spacing: 0.03em;

    position: relative;
    z-index: 1;
    margin: 0;
    font-size: 20px;

    width: 100%;
    max-width: 480px;

    @include media-up(lg) {
      max-width: 600px;
    }

    padding: 0 $container-margin;

    @include media-up(sm) {
      padding-right: 4em;
    }

    @include media-up(xl) {
      font-size: 24px;
    }

    &__heading {
      display: inline-block;
      margin: 0;
      font-size: inherit;
      font-weight: 300;
      width: 100%;
    }

    &--strong &__heading::first-line,
    &__heading /deep/ strong {
      font-weight: 900;
    }

    &::after {
      content: "";
      width: 90%;
      position: absolute;
      bottom: -.4em;
      right: 0;
      height: 1em;
      background-color: $base-opposite-color;
      z-index: -1;
    }

    &__step {
      font-size: .75em;

      position: absolute;
      bottom: -1.2em;
      right: $container-margin;

      @include media-up(md) {
        right: .5em;
        bottom: .2em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StepHeader.vue